// Action Types
export const SEND_OTP_REQUEST_START = 'SEND_OTP_REQUEST_START';
export const SEND_OTP_REQUEST_SUCCESS = 'SEND_OTP_REQUEST_SUCCESS';
export const SEND_OTP_REQUEST_FAIL = 'SEND_OTP_REQUEST_FAIL';

// Payload Types
export type SendOtpPayload = {
    phoneNumber: string;
    organization: string;
};